import { QueryClient as _queryClient } from "@tanstack/react-query";
import { TRPCClientError } from "@trpc/client";

export const queryClient = new _queryClient({
  defaultOptions: {
    queries: {
      // Retry network failures and 5xx (flaky mobile connections), never 4xx —
      // a 401/403/404 won't succeed on retry and would triple auth errors.
      retry: (failureCount, error) => {
        if (failureCount >= 2) {
          return false;
        }

        const httpStatus = error instanceof TRPCClientError
          ? (error.data as { httpStatus?: number } | undefined)?.httpStatus
          : undefined;

        return httpStatus === undefined || httpStatus >= 500;
      },
    },
  },
});
